import { createActionConst } from '../../../utils/action.utils';

const USER_GROUP_NAMESPACE = 'USER_GROUP_NAMESPACE';

export const STORE_USER_GROUP = createActionConst(USER_GROUP_NAMESPACE, 'STORE_USER_GROUP');
export const CLEAR_USER_GROUP = createActionConst(USER_GROUP_NAMESPACE, 'CLEAR_USER_GROUP');
